import type { ILocationRepository, LocationSearchOptions } from '@/features/location/domain/repositories/ILocationRepository.js';

interface Deps { locationRepository: ILocationRepository; }

export function createSearchLocationsByScopeUseCase({ locationRepository }: Deps) {
  return (options: LocationSearchOptions) => locationRepository.searchLocationsByScope(options);
}
